import React from 'react';
import { Radio, RadioChangeEvent } from 'antd';
import useUser from 'vl-core/hooks/useUser';

interface TimezoneSelectorProps {
  onChange: (tz: string) => void;
  patientTimezone?: string;
}

export const TimezoneSelect: React.FC<TimezoneSelectorProps> = ({ onChange, patientTimezone }) => {
  const user = useUser();
  const adminTimezone = user.timezone;

  const options = [
    {
      value: 'admin',
      label: `Your timezone (${adminTimezone})`
    },
    {
      value: 'patient',
      label: `Patient timezone (${patientTimezone})`
    }
  ];

  const handleChangeTimezone = (event: RadioChangeEvent) => {
    const timezone = event.target.value === 'admin' ? adminTimezone : (patientTimezone ?? adminTimezone);
    onChange(timezone);
  };

  return (
    <Radio.Group defaultValue="admin" onChange={handleChangeTimezone}>
      {options.map(({ value, label }) => (
        <Radio key={value} value={value}>
          {label}
        </Radio>
      ))}
    </Radio.Group>
  );
};

export default TimezoneSelect;
